﻿import React from 'react';
import Lottie from 'lottie-react';

import iconAnimData from '../../../AnimationFiles/heart.json';

const LifeIconAnimation = ({ props, container }) => {

    const lottieRef = React.useRef();

    const [hovered, setHovered] = React.useState(false);
    const enter = () => setHovered(true);
    const leave = () => setHovered(false);

    React.useEffect(() => {

        if (container) {
            container.current.addEventListener('mouseenter', enter);

            return () => {
                container.current.removeEventListener('mouseenter', enter);
            };
        }
    }, []);

    React.useEffect(() => {
        if (lottieRef) {

            if (hovered === true) {
                lottieRef.current.play();

                // timeout to ensure animation is completed despite mouseleave
                const timer = setTimeout(leave, 2000);

                return () => clearTimeout(timer);
            }
            if (hovered === false) {
                lottieRef.current.stop();
            }
        }
    }, [hovered])

    return (
        <Lottie
            className="icon"
            lottieRef={lottieRef}
            autoplay={false}
            loop={true}
            animationData={iconAnimData}
        />
    )
}

export default LifeIconAnimation;